import { jsxs as e, Fragment as i, jsx as o } from "react/jsx-runtime";
import { Link as s } from "@mui/material";
const r = {
  title: {
    en: "Manage your cookies",
    es: "Administrar tus cookies",
    "zh-Hans": "管理您的 cookie"
  },
  description: {
    en: /* @__PURE__ */ e(i, { children: [
      "The types of cookies used on this website fall into the following categories - Essential, Insight and Functionality. You can find more information in our",
      " ",
      /* @__PURE__ */ o(
        s,
        {
          href: "https://stenn.com/privacy-policy",
          target: "_blank",
          underline: "hover",
          children: "Privacy and Cookie Policy"
        }
      ),
      ". Please indicate the categories you consent to using, and then click 'Save Settings' to retain your preferences for future visits."
    ] }),
    es: /* @__PURE__ */ e(i, { children: [
      "Los tipos de cookies utilizadas en este sitio web caen en las siguientes categorías - Esencial, Insight y Funcionalidad. Puede encontrar más información en nuestra",
      " ",
      /* @__PURE__ */ o(
        s,
        {
          href: "https://stenn.com/es/privacy-policy",
          target: "_blank",
          underline: "hover",
          children: "Política de privacidad y cookies"
        }
      ),
      ". Por favor, indique las categorías a las que da su consentimiento para utilizar, y luego haga clic en 'Guardar configuración' para conservar sus preferencias para futuras visitas."
    ] }),
    "zh-Hans": /* @__PURE__ */ e(i, { children: [
      "本网站使用的 cookie 类型分为以下几类 - 基本、洞察和功能。您可以在我们的",
      " ",
      /* @__PURE__ */ o(
        s,
        {
          href: "https://stenn.com/zh/privacy-policy",
          target: "_blank",
          underline: "hover",
          children: "隐私和Cookie政策"
        }
      ),
      "中找到更多信息。请指示您同意使用的类别，然后点击“保存设置”以保留您的偏好，供将来访问时使用。"
    ] })
  },
  essentialTitle: {
    en: "Essential",
    es: "Esencial",
    "zh-Hans": "必需的"
  },
  essentialDescription: {
    en: "We use strictly necessary cookies for purposes including showing you our cookie banner when you first access our Services and remembering your decision to accept or decline non-strictly necessary cookies—such cookies will remember your settings for up to a year.",
    es: "Utilizamos cookies estrictamente necesarias con el propósito de mostrarle nuestro aviso de cookies cuando accede por primera vez a nuestros Servicios y recordar su decisión de aceptar o rechazar cookies no estrictamente necesarias; dichas cookies recordarán su configuración durante hasta un año.",
    "zh-Hans": "我们使用严格必要的 cookie 用于以下目的，包括在您首次访问我们的服务时向您显示我们的 cookie 横幅，并记住您对非严格必要 cookie 的接受或拒绝决定 - 这些 cookie 将记住您的设置长达一年。"
  },
  performanceTitle: {
    en: "Performance",
    es: "Rendimiento",
    "zh-Hans": "性能"
  },
  performanceDescription: {
    en: "We and our partners use performance cookies to analyze your use of our Services, including to identify and distinguish different users, and to help us understand how you use the Services (e.g., how much time you spend on which pages on our Site, the time it takes for the page to load, which links you choose to click, the percentage of the page you view, whether you are a previous user of our Site and how much time has passed since your last visit).",
    es: "Nosotros y nuestros socios utilizamos cookies de rendimiento para analizar su uso de nuestros Servicios, incluido identificar y distinguir diferentes usuarios, y para ayudarnos a comprender cómo utiliza los Servicios (por ejemplo, cuánto tiempo pasa en qué páginas en nuestro Sitio, el tiempo que tarda en cargar la página, qué enlaces elige hacer clic, el porcentaje de la página que visualiza, si es un usuario anterior de nuestro Sitio y cuánto tiempo ha pasado desde su última visita).",
    "zh-Hans": "我们和我们的合作伙伴使用性能 cookie 来分析您对我们服务的使用，包括识别和区分不同的用户，并帮助我们了解您如何使用服务（例如，您在我们网站的哪些页面上花费了多少时间，页面加载所需的时间，您选择点击哪些链接，您查看页面的百分比，您是否是我们网站的之前用户以及自上次访问以来过了多长时间）。"
  },
  functionalityTitle: {
    en: "Functionality",
    es: "Funcionalidad",
    "zh-Hans": "功能性"
  },
  functionalityDescription: {
    en: "We use functionality cookies to remember the choices you make with respect to our Services, including your preferred language settings for each session, which last for the duration of your session.",
    es: "Utilizamos cookies de funcionalidad para recordar las elecciones que haces con respecto a nuestros Servicios, incluidas tus configuraciones de idioma preferido para cada sesión, que duran durante la sesión.",
    "zh-Hans": "我们使用功能性 cookie 来记住您对我们服务所做的选择，包括您每个会话的首选语言设置，这些设置将在您的会话期间保留。"
  },
  targetingAdvertisingTitle: {
    en: "Targeting/advertising",
    es: "Publicidad dirgida/promocional",
    "zh-Hans": "定向广告"
  },
  targetingAdvertisingDescription: {
    en: "We and our partners use targeting and advertising cookies to deliver tailored advertisements to you. For example, these cookies are used for identifying unique users and collecting information about your interactions with our Services in order to display ads relevant to you, as well as registering and reporting your actions after clicking or viewing an ad in order to measure the efficiency of the ad.",
    es: "Nosotros y nuestros socios utilizamos cookies de segmentación y publicidad para ofrecerte anuncios personalizados. Por ejemplo, estas cookies se utilizan para identificar usuarios únicos y recopilar información sobre tus interacciones con nuestros servicios con el fin de mostrar anuncios relevantes para ti, además de registrar e informar sobre tus acciones después de hacer clic o ver un anuncio para medir la eficacia del mismo.",
    "zh-Hans": "我们和我们的合作伙伴使用定向和广告 cookie 向您提供定制的广告。例如，这些 cookie 用于识别唯一用户，并收集关于您与我们服务的互动的信息，以显示与您相关的广告，同时注册并报告您在点击或查看广告后的操作，以衡量广告的效果。"
  },
  socialMediaTitle: {
    en: "Social media",
    es: "Redes sociales",
    "zh-Hans": "社交媒体"
  },
  socialMediaDescription: {
    en: "Our Services include social media features, such as links to our social media profiles. These features are either hosted by a third party or hosted directly on our Services.",
    es: "Nuestros servicios incluyen funciones de redes sociales, como enlaces a nuestros perfiles en redes sociales. Estas funciones pueden ser alojadas por un tercero o alojadas directamente en nuestros servicios.",
    "zh-Hans": "我们的服务包括社交媒体功能，例如链接到我们的社交媒体资料的链接。这些功能可以由第三方托管，也可以直接托管在我们的服务上。"
  },
  saveButton: {
    en: "Save",
    es: "Guardar",
    "zh-Hans": "保存选项"
  },
  acceptAllButton: {
    en: "Accept all",
    es: "Aceptar todo",
    "zh-Hans": "接受全部"
  },
  rejectAllButton: {
    en: "Reject all",
    es: "Rechazar todo",
    "zh-Hans": "拒绝全部"
  }
};
export {
  r as messages
};
//# sourceMappingURL=messages3.mjs.map
